<template>
    
    <el-row type="flex" class="page" :gutter="10" justify="center">
        <el-col class="login-form" :xs="14" :sm="8" :md="7" :lg="6">           
            <div >
                <img class="logo" src="../../assets/n2n.png">
           </div>
        </div> 
            <el-form class="login-form-form" @submit.native.prevent="submit" v-model="loginData" >
                <el-form-item class="form-item" :label="$l('login/Username')">
                    <el-input class="form-item" placeholder="" v-model="loginData.username"></el-input>
                </el-form-item>
                <el-form-item class="form-item" :label="$l('login/Password')">
                    <el-input type="password" v-model="loginData.password"></el-input>
                </el-form-item>
                <el-form-item class="button-item login-button">
                    <el-button native-type="submit" @click="loginSubmit" type="primary">{{$l('login/Login')}}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

    </el-row>
</template>

<style>
.page{
    margin-top: 50px;
}
.button-item{
    text-align: center;

}
.login-form{
    background: white; /* For browsers that do not support gradients */
    background: -webkit-linear-gradient(top, white, #f9f9f9); /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(bottom, white, #f9f9f9); /* For Opera 11.1 to 12.0 */
    background: -moz-linear-gradient(bottom, white, #f9f9f9); /* For Firefox 3.6 to 15 */
    background: linear-gradient(white, #f9f9f9); /* Standard syntax */
    border-radius: 5px;
    border: solid 1px rgba(0,0,0,0.15);
    padding: 20px;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.4);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.4);
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.4);
}
.login-form-form{
    padding: 20px;
}
.logo{
    background-color: white;
    border-radius: 5px;
    width: 100%;
    background-color: rgba(0,0,0,0.02);
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
}
.login-button button.el-button--primary{
    margin-top: 20px;
    min-width: 100px;
    background-color: #42c2d0;
    border-color: #42c2d0;
}

.form-item, .form-item input{
    text-align: center;
    margin-top: 4px;
}
.form-item content {
    margin-top: 0;
}

.form-item input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #f9f9f9 inset;
}

.form-item input.el-input__inner{
    border:none;
    border-bottom: 1px solid #42c2d0;
    border-radius: 0px;
    margin-bottom: 15px;
}

    .form-item label {
        margin-left: auto;
        margin-right: auto;
        float: initial;
        color: #b2b2b2;
    }

</style>

<script>
import {loginUser, getUser} from '../../store/actions'

export default {
  data:function(){
      return {
            loginData:{
                username:'',
                password:''
            },
      }
  },
  methods:{
        loginSubmit: function(){
            loginUser(this.$store, this.loginData.username, this.loginData.password)
                .then((data)=>{
                    if(data.username){
                        this.$localStorage.set('token',data.token);
                        this.$localStorage.set('useraccount', JSON.stringify(data));
                        this.$router.push('/');
                    }
                    window.location.reload();
                })
        },
        buttonKeypressed: function(){
            alert('ok');
        }
  },
  mounted: function(){
      getUser(this.$store)
        .then(_=>{
            this.$router.go(-1)
        })
  }
}
</script>





// WEBPACK FOOTER //
// Login.vue?9164d152